import { render, staticRenderFns } from "./SingleGeneExpression.vue?vue&type=template&id=4565aa06&scoped=true"
import script from "./SingleGeneExpression.vue?vue&type=script&lang=js"
export * from "./SingleGeneExpression.vue?vue&type=script&lang=js"
import style0 from "./SingleGeneExpression.vue?vue&type=style&index=0&id=4565aa06&prod&scoped=true&lang=css"
import style1 from "./SingleGeneExpression.vue?vue&type=style&index=1&id=4565aa06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565aa06",
  null
  
)

export default component.exports